import { useToasts } from "react-toast-notifications";
import { useUserInfos } from "../liveblocks/maps";
import { User } from "../types";

const TOAST_ID_NETWORK_ISSUE = "network_issue";
const TOAST_ID_NETWORK_SLOW = "network_slow";
const TOAST_ID_NETWORK_RECOVER = "network_recover";

export function useNetworkStatusToast() {
  const { addToast, removeToast } = useToasts();
  const [users] = useUserInfos();

  function clearAll() {
    removeToast(TOAST_ID_NETWORK_ISSUE);
    removeToast(TOAST_ID_NETWORK_SLOW);
    removeToast(TOAST_ID_NETWORK_RECOVER);
  }

  function networkIssueToast() {
    addToast("Connection lost, please check your network", {
      appearance: "error",
      id: TOAST_ID_NETWORK_ISSUE,
      autoDismiss: false,
    });
  }

  function slowNetworkToast() {
    addToast("Poor connection, please check your network", {
      appearance: "warning",
      id: TOAST_ID_NETWORK_SLOW,
    });
  }

  function networkRecoverToast() {
    clearAll();
    addToast("Network recovered", {
      appearance: "success",
      id: TOAST_ID_NETWORK_RECOVER,
    });
  }

  function userSlowNetworkToast(userId: User["id"]) {
    const user = users[userId];
    if (user) {
      addToast(`${user.name} is experiencing poor connection`, {
        appearance: "warning",
        id: TOAST_ID_NETWORK_SLOW,
      });
    }
  }

  function userNoNetworkToast(userId: User["id"]) {
    const user = users[userId];
    if (user) {
      addToast(`${user.name} experienced network issue and disconnected`, {
        appearance: "warning",
        id: TOAST_ID_NETWORK_SLOW,
      });
    }
  }

  return {
    networkIssueToast,
    slowNetworkToast,
    networkRecoverToast,
    userSlowNetworkToast,
    userNoNetworkToast,
  };
}
